module.exports = __webpack_public_path__ + "static/media/notice1.899289d9.png";